import {
  TERMS_CREATE_REQUEST,
  TERMS_CREATE_SUCCESS,
  TERMS_CREATE_FAILURE,
  TERMS_LIST_REQUEST,
  TERMS_LIST_SUCCESS,
  TERMS_LIST_FAILURE,
  TERMS_GET_REQUEST,
  TERMS_GET_SUCCESS,
  TERMS_GET_FAILURE,
  TERMS_UPDATE_REQUEST,
  TERMS_UPDATE_SUCCESS,
  TERMS_UPDATE_FAILURE,
  TERMS_DELETE_REQUEST,
  TERMS_DELETE_SUCCESS,
  TERMS_DELETE_FAILURE,
} from '../actions/termsActions';

const createInitial = { loading: false, error: null, data: null };
const listInitial = { loading: false, error: null, data: null };
const detailInitial = { loading: false, error: null, data: null };
const updateInitial = { loading: false, error: null, data: null };
const deleteInitial = { loading: false, error: null, success: false };

export default function terms(state = {
  create: createInitial,
  list: listInitial,
  detail: detailInitial,
  update: updateInitial,
  remove: deleteInitial,
}, action) {
  switch (action.type) {
    case TERMS_CREATE_REQUEST:
      return { ...state, create: { loading: true, error: null, data: null } };
    case TERMS_CREATE_SUCCESS:
      return { ...state, create: { loading: false, error: null, data: action.payload } };
    case TERMS_CREATE_FAILURE:
      return { ...state, create: { loading: false, error: action.error || 'Failed to create term', data: null } };

    case TERMS_LIST_REQUEST:
      return { ...state, list: { loading: true, error: null, data: null } };
    case TERMS_LIST_SUCCESS:
      return { ...state, list: { loading: false, error: null, data: action.payload } };
    case TERMS_LIST_FAILURE:
      return { ...state, list: { loading: false, error: action.error || 'Failed to fetch terms', data: null } };

    case TERMS_GET_REQUEST:
      return { ...state, detail: { loading: true, error: null, data: null } };
    case TERMS_GET_SUCCESS:
      return { ...state, detail: { loading: false, error: null, data: action.payload } };
    case TERMS_GET_FAILURE:
      return { ...state, detail: { loading: false, error: action.error || 'Failed to fetch term', data: null } };

    case TERMS_UPDATE_REQUEST:
      return { ...state, update: { loading: true, error: null, data: null } };
    case TERMS_UPDATE_SUCCESS:
      return { ...state, update: { loading: false, error: null, data: action.payload } };
    case TERMS_UPDATE_FAILURE:
      return { ...state, update: { loading: false, error: action.error || 'Failed to update term', data: null } };

    case TERMS_DELETE_REQUEST:
      return { ...state, remove: { loading: true, error: null, success: false } };
    case TERMS_DELETE_SUCCESS:
      return { ...state, remove: { loading: false, error: null, success: true } };
    case TERMS_DELETE_FAILURE:
      return { ...state, remove: { loading: false, error: action.error || 'Failed to delete term', success: false } };

    default:
      return state;
  }
}


